import { FunctionComponent } from "react";

import { Stack, Text, TooltipHost } from "@bps/fluent-ui";
import { useBpIdUserDetails } from "@libs/api/gateways/bp-id/bp-id.hooks";

interface TenantLinkProps {
  bpIdUserId: string;
}
export const UserLink: FunctionComponent<TenantLinkProps> = ({
  bpIdUserId
}) => {
  const { data: user } = useBpIdUserDetails(bpIdUserId);
  return (
    <TooltipHost
      content={
        <Stack horizontal>
          <Text bold>Application</Text>
          <Text bold>Created Date</Text>
          <Text>{user?.createdDate}</Text>
        </Stack>
      }
    >
      {user?.displayName}
    </TooltipHost>
  );
};
